<div class="page">
  <ng-content select="[slot=header]"></ng-content>
  <main [class.page__content--white]="backgroundColor === 'white'" class="page__content">
    <ng-content></ng-content>
  </main>
  <ng-content select="[slot=footer]"></ng-content>
</div>
